<div class="container">
  <div class="row">
    <a class="back-button pr-3 pl-0 back-btn-white-bg ng-star-inserted mt-3" *ngIf="!previousUrl" routerLink="../users">
      <i aria-hidden="true" class="fa fa-chevron-circle-left"></i>Back</a>
    <a class="back-button pr-3 pl-0 back-btn-white-bg ng-star-inserted mt-3" *ngIf="previousUrl" (click)="onBack()">
      <i aria-hidden="true" class="fa fa-chevron-circle-left"></i>Back</a>
    <!-- <button class="back-button pr-3 pl-0 back-btn-white-bg ng-star-inserted" ><i aria-hidden="true" class="fa fa-chevron-circle-left"></i>Back</button> -->
  </div>
  <mat-tab-group color="primary">
    <mat-tab label="Create Users">
      <div class="container p-0">
        <mat-horizontal-stepper labelPosition="bottom" #stepper (selectionChange)="selectionChange($event)">
          <mat-step stepControl="userDetails">
            <ng-template matStepLabel>User Details</ng-template>
            <manage-user (selectedCompany)="handleCompanySelection($event)" (onClickSave)="onAttoneySaveBack()"></manage-user>
          </mat-step>
          <mat-step stepControl="roles" *ngIf="isStepperVisible">
            <ng-template matStepLabel>Roles & Permission</ng-template>
            <roles-permissions [employeeCompany]="employeeCompany"></roles-permissions>
          </mat-step>
          <mat-step stepControl="login" *ngIf="isStepperVisible">
            <ng-template matStepLabel>Login Credentials</ng-template>
            <login-credentials [employeeCompany]="employeeCompany"></login-credentials>
          </mat-step>
        </mat-horizontal-stepper>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
